module.exports = __webpack_public_path__ + "static/media/993806.6adc112c.png";